import React from "react";
import useIsMobile from "../../common/hooks/useIsMobile";

function Icon() {
  const isMobile = useIsMobile()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={!isMobile? "8vw" : "16vw"}
      height={!isMobile? "4vw" : "10vw"}
      fill="none"
      viewBox="0 0 78 21"
    >
      <path
        fill="#6F6F6F"
        d="M61.76 6.43l2.882-2.12h-9.646v12.74h9.646v-2.122h-6.894v-3.261h5.88V9.545h-5.88V6.43h4.011zM47.712 9.276h-3.35V6.43h5.348l2.882-2.12H41.61v12.74h5.748c3.225 0 5.073-1.46 5.073-4.003 0-2.432-1.675-3.771-4.718-3.771zm-.483 5.652h-2.87v-3.531h2.87c1.747 0 2.56.59 2.56 1.765 0 1.2-.86 1.766-2.56 1.766zM72.457 4.31H67.2v12.74h2.752v-3.61h2.5c3.352 0 5.434-1.76 5.434-4.571 0-2.812-2.082-4.56-5.434-4.56m-.059 7.01h-2.44V6.43h2.44c1.764 0 2.734.869 2.734 2.445 0 1.576-.971 2.444-2.734 2.444zM36.884 14.29c-.73.396-1.548.6-2.379.596-2.481 0-4.283-1.77-4.283-4.206 0-2.437 1.802-4.2 4.283-4.2a4.205 4.205 0 012.504.782l1.975-1.453-.13-.115c-1.157-1.01-2.693-1.545-4.455-1.545-1.91 0-3.645.642-4.882 1.811-1.238 1.169-1.931 2.829-1.931 4.655s.683 3.513 1.923 4.725c1.24 1.211 2.975 1.883 4.872 1.883 1.985 0 3.718-.69 4.892-1.947l-1.781-1.312-.608.327zM21.035 10.5c0-.631-.056-1.26-.168-1.882l-2.264 1.666v.216a8.077 8.077 0 01-1.716 4.985A8.11 8.11 0 017.2 17.889a8.092 8.092 0 01-3.854-3.603 8.074 8.074 0 011.768-9.81 8.104 8.104 0 019.96-.643L17.12 2.33a10.526 10.526 0 00-13.125-.067 10.486 10.486 0 00-2.967 12.766 10.508 10.508 0 004.905 4.922 10.531 10.531 0 0012.8-2.898 10.49 10.49 0 002.299-6.552h.003z"
      ></path>
      <path
        fill="#6F6F6F"
        d="M18.841 4.08c.5.644.924 1.344 1.262 2.087l-9.582 7.051-4.003-2.506V7.697l4.003 2.507 8.32-6.125z"
      ></path>
    </svg>
  );
}

export default Icon;
